document.addEventListener('DOMContentLoaded', function () {
  function setupDropdowns() {
    const faqHeadings = document.querySelectorAll('.faq-heading');
    faqHeadings.forEach((heading) => {
      const faqItem = heading.closest('.faq-content');
      const answer = faqItem.querySelector('.faq-answer');
      const icon = heading.querySelector('svg');

      answer.style.maxHeight = "0px";

      heading.addEventListener('click', function () {
        
        const isActive = heading.classList.contains('active');

        if (isActive) {
          heading.classList.remove('active');
          answer.style.maxHeight = answer.scrollHeight + "px";
          setTimeout(() => { answer.style.maxHeight = "0px"; }, 10);
          setTimeout(() => { answer.classList.remove('active'); }, 400);
          if (icon) icon.style.transform = 'rotate(0deg)';
        } else {
          document.querySelectorAll('.faq-heading.active').forEach((activeHeading) => {
            if (activeHeading !== heading) {
              activeHeading.classList.remove('active');
              const activeFaqItem = activeHeading.closest('.faq-content');
              const activeAnswer = activeFaqItem.querySelector('.faq-answer');

              activeAnswer.style.maxHeight = activeAnswer.scrollHeight + "px";
              setTimeout(() => { activeAnswer.style.maxHeight = "0px"; }, 10);
              setTimeout(() => { activeAnswer.classList.remove('active'); }, 400);

              const activeIcon = activeHeading.querySelector('svg');
              if (activeIcon) activeIcon.style.transform = 'rotate(0deg)';
            }
          });

          heading.classList.add('active');
          answer.classList.add('active');
          answer.style.maxHeight = answer.scrollHeight + "px";
          if (icon) icon.style.transform = 'rotate(180deg)';
        }
      });
    });
  }

  setupDropdowns();

  // Load More — batch size must stay in sync with section `visible_limit` (data-faq-batch-size on #faq-container)
  const loadMoreBtn = document.getElementById('load-more');
  const faqContainer = document.getElementById('faq-container');
  const faqItems = document.querySelectorAll('.faq-item');
  const batchSize = Math.max(
    1,
    parseInt(faqContainer?.dataset.faqBatchSize || '4', 10) || 4
  );
  const initialVisible = Math.max(
    1,
    parseInt(faqContainer?.dataset.faqInitialVisible || String(batchSize), 10) || batchSize
  );

  let currentIndex = initialVisible;

  faqItems.forEach((item, index) => {
    if (index < initialVisible) {
      item.style.display = 'flex';
      item.style.opacity = '1';
    } else {
      item.style.display = 'none';
    }
  });

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      let nextItems = Array.from(faqItems).slice(currentIndex, currentIndex + batchSize);

      nextItems.forEach((item, index) => {
        setTimeout(() => {
          item.style.display = 'flex';
          item.style.opacity = '0';
          item.style.transition = 'opacity 0.5s ease-in-out';
          setTimeout(() => {
            item.style.opacity = '1';
          }, 50);
        }, index * 100); // Delay each item slightly for a cascading effect
      });

      currentIndex += nextItems.length;

      if (currentIndex >= faqItems.length) {
        loadMoreBtn.style.display = 'none'; // Hide button when all items are shown
      }
    });
  }
});